const testimonials = [
  {
    name: "Jennifer K.",
    location: "Minnetonka, MN",
    rating: 5,
    text: "I work at UnitedHealth Group and received a last-minute assignment to Singapore with twelve days notice. My passport had expired. Fast Passport Center processed my renewal in five business days. I made my flight and the project was a success. Their document review is exceptional.",
    service: "Passport Renewal",
  },
  {
    name: "The Anderson Family",
    location: "Lake Minnetonka Area",
    rating: 5,
    text: "We planned a summer trip to our cabin in Ontario and discovered our daughter's passport had expired. Fast Passport Center handled her child passport expedited in six business days. We made our annual lake trip without any delay. Highly professional.",
    service: "Child Passport",
  },
  {
    name: "Robert M.",
    location: "Minnetonka, MN",
    rating: 5,
    text: "I had a conference in Frankfurt with three weeks notice. My passport was within three months of expiration. Fast Passport Center guided me through the renewal process, reviewed my documents, and had my passport back in four business days. Outstanding service.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MinnetonkaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Minnetonka &amp; Western Metro Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Minnetonka, Lake Minnetonka, and Hennepin County travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}